import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";

// Shown app-wide when an admin has scoped-banned this account from the members area.
// Login, owned purchases and billing stay available; the subscription is not changed.
export const MembersBanBanner = () => {
  const { membersBanned } = usePlatformAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!membersBanned) return null;

  return (
    <div
      data-testid="members-ban-banner"
      className="w-full px-6 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 text-center"
      style={{ background: "#3f3f46", color: "#fff" }}
    >
      <ShieldAlert size={18} className="shrink-0" />
      <span className="text-sm font-medium" data-testid="members-ban-message">
        {t("billing.membersBannedBanner")}
      </span>
      <button
        onClick={() => navigate("/account/billing")}
        data-testid="members-ban-billing-btn"
        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap"
        style={{ background: "#fff", color: "#3f3f46" }}
      >
        {t("billing.membersBannedCta")}
      </button>
    </div>
  );
};

export default MembersBanBanner;
